import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  create_grooming_package,
  delete_grooming_package,
  fetch_grooming_packages,
  fetch_public_grooming_packages,
  update_grooming_package,
} from './api';
import type { CreateGroomingPackageInput, UpdateGroomingPackageInput } from './types';

const PACKAGES_KEY = ['grooming-packages'] as const;

export function use_grooming_packages(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: PACKAGES_KEY,
    queryFn: fetch_grooming_packages,
    enabled: options?.enabled ?? true,
  });
}

/** Public salon packages (tiers) for the pet-owner booking surface. */
export function use_public_grooming_packages(vendor_id: string, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['grooming-packages', 'public', vendor_id],
    queryFn: () => fetch_public_grooming_packages(vendor_id),
    enabled: options?.enabled ?? true,
  });
}

export function use_create_grooming_package() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateGroomingPackageInput) => create_grooming_package(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: PACKAGES_KEY }),
  });
}

export function use_update_grooming_package() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateGroomingPackageInput }) =>
      update_grooming_package(id, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: PACKAGES_KEY }),
  });
}

export function use_delete_grooming_package() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => delete_grooming_package(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: PACKAGES_KEY }),
  });
}
